/** Cookie de consentimento de analytics (GA + ingest público). */
export const COOKIE_CONSENT_NAME = 'xat_ajuda_cookie_consent';
export const COOKIE_CONSENT_ACCEPTED = 'accepted';
export const COOKIE_CONSENT_DECLINED = 'declined';

export function readCookieConsent(): 'accepted' | 'declined' | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${COOKIE_CONSENT_NAME}=([^;]*)`));
  if (!match) return null;
  const value = decodeURIComponent(match[1]);
  if (value === COOKIE_CONSENT_ACCEPTED) return 'accepted';
  if (value === COOKIE_CONSENT_DECLINED) return 'declined';
  return null;
}

export function hasAnalyticsConsent(): boolean {
  return readCookieConsent() === 'accepted';
}

export function setCookieConsent(value: 'accepted' | 'declined', days = 365): void {
  if (typeof document === 'undefined') return;
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${COOKIE_CONSENT_NAME}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  window.dispatchEvent(new CustomEvent('xat-cookie-consent-changed', { detail: value }));
}
